import owayo_menu from "owayo_menu";
export default defineNuxtPlugin(({ vueApp }) => {
    vueApp.use(owayo_menu);
});
//# sourceMappingURL=owayomenu.js.map